import React from 'react'
import { NOTIFY } from './NotifierActions'

export default function () {
	const initialState = {}
	return (state = initialState, action = {}) => {
		switch (action.type) {

			case NOTIFY: {
				if (action.notification) {
					let msg = Object.assign([], action.notification.message)
					if (typeof(action.notification.message) === 'string') {
						msg = <div>{action.notification.message}</div>
					} else if (msg.length) {
						for (const i in msg) {
							if (typeof(msg[i]) === 'string') {
								msg[i] = <div key={`notif-msg-${i}`} dangerouslySetInnerHTML={{ __html: `${msg[i]}` }} />
							}
						}
					}

					return {
						...state,
						notification: {
							children: (<div>{msg}</div>),
							level: action.notification.level ? action.notification.level : 'success',
							position: action.notification.position ? action.notification.position : 'tc',
							autoDismiss: action.notification.autoDismiss
							|| action.notification.autoDismiss === 0 ? action.notification.autoDismiss : 5,
							uid: action.notification.uid,
							onlineChanged: false
						}
					}
				}
				return state
			}

			default: {
				return state
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/notifier/NotifierReducer.js